export default {
  colorButton: color => ({
    borderRadius: '50%',
    width: '40px',
    height: '40px',
    border: `2px solid ${color}`,
  }),
  colorPicker: {
    position: 'absolute',
    zIndex: 2,
  },
  uploadContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  actionButton: {
    textTransform: 'none',
    '&:not(:first-of-type)': {
      marginLeft: '16px',
    },
  },
  actionButtons: {
    padding: '16px 24px',
  },
  qrRedirectUrl: {
    wordBreak: 'break-all',
    overflowWrap: 'break-word',
    maxWidth: '100%',
    display: 'inline-block',
    textAlign: 'center',
  },
  openLinkButton: {
    textTransform: 'none',
  },
  notLiveHint: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
};
